<template>
  <t-form labelWidth="100px">
    <t-form-item label="尺寸">
      <t-radio-group v-model="attribute.size" size="small">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
        <t-radio-button value="large">大</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="按钮方向">
      <t-radio-group v-model="attribute.layout" size="small">
        <t-radio-button value="horizontal">左右</t-radio-button>
        <t-radio-button value="vertical">上下</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <e-collapse title="自动触发" :expand="true">
      <t-form-item label="自动触发">
        <t-switch v-model="attribute.autoSwitch" size="small" :label="['开', '关']"/>
      </t-form-item>
      <t-form-item label="触发延时(s)">
        <t-input-number :min="1" :max="100" v-model="attribute.timeout" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="触发类型">
        <t-radio-group v-model="attribute.trigger" size="small">
          <t-radio-button value="prev">上一页</t-radio-button>
          <t-radio-button value="current">首页</t-radio-button>
          <t-radio-button value="next">下一页</t-radio-button>
        </t-radio-group>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
export default {
  name: "cpt-jumper-option",
  props: {attribute: Object},
}
</script>

<style scoped>

</style>